
import {Component, OnInit} from '@angular/core';
import {CellValue} from '@shared/models/paged-response-model';
import {CellEditorComponentBase} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';


@Component({
    standalone: false,
    selector: 'app-dialog-field-country-selector-editor',
  templateUrl: './dialog-field-country-selector-editor.component.html',
  styleUrls: ['./dialog-field-country-selector-editor.component.scss']
})
export class DialogFieldCountrySelectorEditorComponent extends DialogDefinitionEditorBase implements OnInit {

  configKey: string;
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.dialogField.value) {
      this.dialogField.value = [];
    }

    if (this.dialogField?.fieldValues?.ConfigKey) {
      this.configKey = this.dialogField?.fieldValues?.ConfigKey;
    }
  }

  onSelectionChanged($event: any) {
    this.dynamicFormControl.setValue($event.map(o => o.value.code));
  }
}
